/* eslint-disable no-undef */
import React from 'react';
import './style.sass';

const Benefits = () => (
  <div className="box-shadow">
    <div className="sidebar">
      <h3 className="sidebar-header">{I18n.t('sidebar.benefits.title')}</h3>
      <ul className="ticked-list">
        <li>{I18n.t('sidebar.benefits.flexible_agreements')}</li>
        <li>{I18n.t('sidebar.benefits.no_start_up_costs')}</li>
        <li>{I18n.t('sidebar.benefits.offices_for_1_to_20')}</li>
        <li>{I18n.t('sidebar.benefits.services_included')}</li>
      </ul>
    </div>
  </div>
);

export default Benefits;
